import { PermissionCategory } from "./permission-category.model";

export class Permission {
    url!: string;
    title!: string;
    icon?: string;
    code!: string;
    canCreate!: boolean;
    canRead!: boolean;
    canUpdate!: boolean;
    canDelete!: boolean;
    external!: boolean;
    active: boolean;
    jsFunction!: string;
    showMenu!: boolean;
    categories?: PermissionCategory[];
    isFavorite!: boolean;

    constructor() {
        this.active = false;
    }
}